<template>
  <div class="car-archive">
    <div class="search-warehouse">
      <div class="screen">
        <el-input class="white w200" v-model="search.vin" placeholder="请输入车架号"></el-input>
        <el-select 
          class="white w200" 
          clearable 
          v-model="search.collectorId" 
          placeholder="请选择采集员"
          v-lazy-load-dropdown="handleCollectScrollDropdown">
          <el-option
            v-for="item in collectTypeOptionsList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select class="white w200" clearable v-model="search.vehicleStatus" placeholder="请选择车辆情况">
          <el-option
            v-for="item in vehicleConditionList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-date-picker
          class="w240"
          v-model="search.collectDate"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-button class="btn-blue" @click="onSearch">搜索</el-button>
      </div>
    </div>
    <div class="table">
      <el-table ref="table" :data="carArchive" style="width: 100%">
        <el-table-column 
          v-for="(item, index) in tableTitleList"
          :key="index"
          :label="item.label"
          :prop="item.prop"
        >
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button class="btn-text" type="text" @click="lookDetails(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer">
      <pagination-tpl
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @queryChange="queryChange"
      ></pagination-tpl>
    </div>
  </div>
</template>

<script>
import { modifyNetTitle, formaTimeToAllSecond } from "common/js/util";
import PaginationTpl from "components/base/PaginationTpl";
import CollectMixins from "common/mixins/smart-vehicle-inspection/collect";
import SmartVehicleInspection from "models/smart-vehicle-inspection/smart-vehicle-inspection";
export default {
  mixins: [CollectMixins],
  data() {
    return {
      search: {
        vin: '',
        vehicleStatus: '',
        collectorId: '',
        collectDate: ''
      },
      carArchive: [],
      tableTitleList: [
        {label: '车架号', prop: 'vin'},
        {label: '车辆情况', prop: 'vehicleConditionVal'},
        {label: '作业类型', prop: 'assignmentTypeVal'},
        {label: '采集时间', prop: 'submitTime'},
        {label: '采集员', prop: 'collectorName'},
      ],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      vehicleConditionList: [
        {id:0, name: '正常'},
        {id:1, name: '有质损'}
      ]
    };
  },
  components: {
    PaginationTpl
  },
  created() {
    modifyNetTitle('车辆影像档案')
    this.initCarArchive();
    this.initCollectList();
  },
  methods: { 
    initCarArchive() {
      let data = this.search
      data.startDate = this.search.collectDate ? this.search.collectDate[0] : '';
      data.endDate = this.search.collectDate ? this.search.collectDate[1] : '';
      data.pageNo = this.currentPage
      data.pageSize = this.pageSize
      SmartVehicleInspection.getCarArchive(data).then(res => {
        if (res.success) {
          const { records, total, size } = res.result
          this.pageSize = size;
          this.total = total;
          let arr = [];
          records.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.vin = value.vin;
            obj.collectorId = value.collectorId;
            obj.collectorName = value.collectorName;
            obj.submitTime = value.submitTime ? formaTimeToAllSecond(value.submitTime) : '';
            obj.vehicleStatus = value.vehicleStatus;
            obj.vehicleConditionVal = value.vehicleStatus === 0?'正常':'有质损';
            obj.jobType = value.jobType;
            obj.assignmentTypeVal = value.jobType === 1?'接收检验':'移交检验';
            arr.push(obj);
          });
          this.carArchive = arr;
        }
      })
    },

    //翻页
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initCarArchive();
    },

    onSearch() {
      this.initCarArchive()
    },

    lookDetails(row) {
      this.$router.push({
        path: '/vehicle/homework-center/archive/car-archive-details',
        query: {
          id: row.id,
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.car-archive {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  .search-warehouse {
    margin-bottom: 16px;
    .screen {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .w200 {
        width: 200px;
        margin-right: 16px;
      }
      .w240 {
        width: 240px;
        margin-right: 16px;
      }
    }
  }
  
  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 16px;
  }
}
</style>
